//import MercadoPagoConfirm from "../views/shopping_cart/MercadoPagoConfirm.vue";

export const CheckoutRouter = [
  {
    path: '/checkout',
    name: 'Checkout',
    meta: { layout: 'ChuspicLayout' },
    component: () => import('@/views/shopping_cart/Checkout.vue')
  },
  {
    path: '/checkout/thank-you',
    name: 'Checkout.ThankYou',
    component: () => import('@/views/shopping_cart/ThankYou.vue')
  },
  {
    path: '/checkout/pending-order',
    name: 'Checkout.PendingOrder',
    component: () => import('@/views/shopping_cart/PendingOrder.vue'),
  },    
  {
    path: '/checkout/paypal-confirmation',
    name: 'Checkout.PaypalConfirm',
    component: () => import('@/views/shopping_cart/PaypalConfirm.vue')
  },
  {
    path: '/checkout/pending-oxxo',
    name: 'Checkout.PendingOxxo',
    component: () => import('@/views/shopping_cart/PendingOxxo.vue')
  },
  //{
  //path: '/checkout/mercado-pago-confirmation',
  //name: 'Checkout.MercadoPagoConfirm',
  //component: MercadoPagoConfirm
  //},
  {
    path: '/checkout/vita-wallet-success',
    name: 'Checkout.VitaWalletSuccess',
    component: () => import('@/views/shopping_cart/Providers/VitaWallet/Success.vue')
  },
  {
    path: '/checkout/vita-wallet-pending',
    name: 'Checkout.VitaWalletPending',
    component: () => import('@/views/shopping_cart/Providers/VitaWallet/Pending.vue')
  },
  {
    path: '/checkout/vita-wallet-error',
    name: 'Checkout.VitaWalletError',
    component: () => import('@/views/shopping_cart/Providers/VitaWallet/Error.vue')
  },
  {
    path: '/checkout/vita-wallet-cancel',
    name: 'Checkout.VitaWalletCancel',
    component: () => import('@/views/shopping_cart/Providers/VitaWallet/Cancel.vue')
  },
];